var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showCounter>0 && (this.displayMinutes!=0 || this.displaySeconds!=0))?_c('span',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.displayDays)+":"+_vm._s(_vm.displayHours)+":"+_vm._s(_vm.displayMinutes)+":"+_vm._s(_vm.displaySeconds)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }